import { formatResearchMode } from "./researchModes";

export function parseExecutionReportAsset(asset) {
  if (!asset || asset.asset_type !== "execution_report" || !asset.body) return null;
  try {
    const parsed = JSON.parse(asset.body);
    if (!parsed || parsed.version !== "agent_workflow_v2") return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

export function getExecutionReportAsset(assets = []) {
  return assets.find((asset) => asset?.asset_type === "execution_report") || null;
}

export function getExecutionReport(assets = []) {
  return parseExecutionReportAsset(getExecutionReportAsset(assets));
}

export function formatReportList(values = [], fallback = "Not specified") {
  if (!Array.isArray(values) || values.length === 0) return fallback;
  return values.filter(Boolean).join("; ") || fallback;
}

export function formatDurationMs(value) {
  if (value === undefined || value === null || Number.isNaN(Number(value))) return "Not recorded";
  const ms = Math.max(0, Math.round(Number(value)));
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60000) {
    const seconds = ms / 1000;
    return `${Number.isInteger(seconds) ? seconds.toFixed(0) : seconds.toFixed(2).replace(/0+$/, "").replace(/\.$/, "")}s`;
  }
  const minutes = Math.floor(ms / 60000);
  const seconds = Math.round((ms % 60000) / 1000);
  return `${minutes}m ${seconds}s`;
}

export function formatResearchDecisionRows(report) {
  const decision = report?.research_decision || {};
  const hasDecision = Boolean(
    decision.provider
    || decision.query
    || decision.focus
    || decision.source_count !== undefined
  );
  if (!hasDecision) return [];

  const rows = [
    ["Research mode", formatResearchMode(decision.mode || report?.research_mode)],
    ["Research provider", decision.provider || "Not recorded"],
    ["Search query", decision.query || "Not recorded"],
    ["Research focus", decision.focus || "general"],
    ["Sources found", decision.source_count ?? report?.source_digest?.source_count ?? 0],
  ];
  if (decision.status) rows.push(["Research status", decision.status]);
  if (decision.error) rows.push(["Research issue", decision.error]);
  return rows;
}

export function formatSourceDigestRows(report) {
  const digest = report?.source_digest || {};
  const rows = [];
  if (digest.status) rows.push(["Digest status", digest.status]);
  if (digest.error) rows.push(["Digest issue", digest.error]);
  return rows;
}
